import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localStorageService } from '../../services/local-storage.service';
import {
  requestLoginWithSessionId,
  logout as logoutAction,
  revokeToken,
} from '../../store/modules/auth/actions';
import { Loading } from '../report/shared/components/Loading';

export function RedirectPage() {
  const dispatch = useDispatch();
  const loginSessionState = useSelector((state: any) => state.auth?.login);
  const wlConfig = useSelector((state: any) => state?.whitelabel?.config);

  const wlLoginUrl = wlConfig.login_url;

  const { loadingSessionId, successSessionId, errorSessionId } =
    loginSessionState;

  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('sessionId');
  const toPath = urlParams.get('toPath');

  // Função auxiliar para redirecionar para login
  const redirectToLogin = () => {
    dispatch(logoutAction());
    dispatch(revokeToken());
    const loginUrl = wlLoginUrl && wlLoginUrl !== '' ? wlLoginUrl : '/login';
    window.location.replace(loginUrl);
  };

  // Função auxiliar para validar dados de autenticação
  const validateAuthData = () => {
    const legacyToken = localStorageService.getLocalStorageItem({
      key: 'user_token_login_info',
    })?.legacy_token;
    const tokenInfo = localStorageService.getLocalStorageItem({
      key: 'user_token_login_info',
    });
    const poliAccess = window.localStorage.getItem('poli_access');

    return {
      isValid: !!(legacyToken && tokenInfo && poliAccess),
      legacyToken,
      tokenInfo,
      poliAccess,
    };
  };

  // Valida sessionId e dispara o login
  useEffect(() => {
    // Se não tiver sessionId, redireciona para login
    if (!sessionId) {
      redirectToLogin();
      return;
    }

    // Evita múltiplas tentativas de login
    // Só dispara se não estiver carregando, não tiver sucesso e não tiver erro
    if (!loadingSessionId && !successSessionId && !errorSessionId) {
      try {
        dispatch(requestLoginWithSessionId(sessionId));
      } catch (error) {
        redirectToLogin();
      }
    }
  }, [sessionId, dispatch, loadingSessionId, successSessionId, errorSessionId]);

  // Trata o resultado do login (sucesso ou erro)
  useEffect(() => {
    // Trata o sucesso do login
    if (successSessionId && !loadingSessionId && !errorSessionId) {
      const authData = validateAuthData();

      if (authData.isValid) {
        // Delay para garantir que todos os dados estão salvos e a saga setou o current_customer_id no Redux
        setTimeout(() => {
          const destination = toPath || '/chat';
          window.location.replace(destination);
        }, 1000);
      } else {
        // Se os dados não estão completos, loga erro e redireciona para login
        // manter esse log para auditoria
        console.error(
          'Erro ao validar dados de autenticação, redirecionando para login',
          authData
        );
        redirectToLogin();
      }
      return;
    }

    // Trata o erro do login
    if (errorSessionId && !loadingSessionId) {
      // manter esse log para auditoria
      console.error(
        'Erro ao validar dados de autenticação, redirecionando para login',
        errorSessionId,
        loadingSessionId
      );
      redirectToLogin();
    }
  }, [
    successSessionId,
    loadingSessionId,
    errorSessionId,
    toPath,
    dispatch,
    wlLoginUrl,
  ]);

  return (
    <div
      style={{
        width: '100dvw',
        height: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loading />
    </div>
  );
}
